import React from "react";
import { useTranslation } from "react-i18next";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import { getContenidoTabLabelKey } from "../utils/contenidoIntermedio";
import "./BusinessViewSwitcher.css";

/**
 * Segmented control fijo Carta/Info/Programa ↔ Propinas para business
 * con contenido intermedio activo. `active`: "content" | "tips".
 */
const BusinessViewSwitcher = ({
  tipo = "menu",
  active,
  onSelectContent,
  onSelectTips,
}) => {
  const { t } = useTranslation();

  return (
    <div className="business-view-switcher" role="tablist">
      <button
        type="button"
        role="tab"
        aria-selected={active === "content"}
        className={`business-view-switcher-tab${
          active === "content" ? " business-view-switcher-tab--active" : ""
        }`}
        onClick={() => {
          if (active !== "content") onSelectContent?.();
        }}
      >
        <RestaurantMenuIcon sx={{ fontSize: 18 }} />
        <span>{t(getContenidoTabLabelKey(tipo))}</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === "tips"}
        className={`business-view-switcher-tab${
          active === "tips" ? " business-view-switcher-tab--active" : ""
        }`}
        onClick={() => {
          if (active !== "tips") onSelectTips?.();
        }}
      >
        <VolunteerActivismIcon sx={{ fontSize: 18 }} />
        <span>{t("landing.tabTips")}</span>
      </button>
    </div>
  );
};

export default BusinessViewSwitcher;
